import { CustomInputComponent } from "./CustomInput";
import { RectangleButton } from "./CustomButton/RectangleButton";
import { EllipticalButton } from "./CustomButton/EllipticalButton";

const CustomInput = CustomInputComponent;
const CustomRectangleButton = RectangleButton;
const CustomEllipticalButton = EllipticalButton;

export { CustomInput, CustomRectangleButton, CustomEllipticalButton };
